import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import type { FilterConfig } from '../TableViewTypes'

interface CustomFilterDropdownProps {
  columnKey: string
  actualFilterKey: string
  CustomFilterComponent: React.ComponentType<any>
  selectedKeys: React.Key[]
  setSelectedKeys: (selectedKeys: React.Key[]) => void
  confirm: () => void
  clearFilters: () => void
  onFiltersChange?: (filters: FilterConfig) => void
}

export default function CustomFilterDropdown({
  actualFilterKey,
  CustomFilterComponent,
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  onFiltersChange
}: CustomFilterDropdownProps) {
  return (
    <CustomFilterComponent
      selectedKeys={selectedKeys}
      setSelectedKeys={setSelectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
      onFilterChange={(filterValue: any) => {
        const filterConfig: FilterConfig = {}

        const hasMeaningfulContent =
          filterValue &&
          !(Array.isArray(filterValue) && filterValue.length === 0) &&
          !(typeof filterValue === 'object' && Object.keys(filterValue).length === 0)

        if (hasMeaningfulContent) {
          const filterValueToStore =
            Array.isArray(filterValue) && filterValue.length > 0 && filterValue[0]?.value !== undefined
              ? filterValue[0].value
              : filterValue
          filterConfig[actualFilterKey] = filterValueToStore
        } else {
          filterConfig[actualFilterKey] = undefined
        }

        onFiltersChange?.(filterConfig)
      }}
    />
  )
}

export function CustomFilterIcon(filtered: boolean) {
  return <FontAwesomeIcon icon={faFilter} style={{ color: filtered ? '#1890ff' : '#9CA3AF', padding: '0 4px' }} />
}
